/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateSigintSensorForm,
  CreateSigintSensorForm$Outbound,
  CreateSigintSensorForm$outboundSchema,
} from "../components/createsigintsensorform.js";

export type CreateSigintSensorSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateSigintSensorSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateSigintSensorSecurity = {
  option1?: CreateSigintSensorSecurityOption1 | undefined;
  option2?: CreateSigintSensorSecurityOption2 | undefined;
};

export type CreateSigintSensorRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createSigintSensorForm: CreateSigintSensorForm;
};

/** @internal */
export type CreateSigintSensorSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateSigintSensorSecurityOption1$outboundSchema: z.ZodMiniType<
  CreateSigintSensorSecurityOption1$Outbound,
  CreateSigintSensorSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createSigintSensorSecurityOption1ToJSON(
  createSigintSensorSecurityOption1: CreateSigintSensorSecurityOption1,
): string {
  return JSON.stringify(
    CreateSigintSensorSecurityOption1$outboundSchema.parse(
      createSigintSensorSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateSigintSensorSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateSigintSensorSecurityOption2$outboundSchema: z.ZodMiniType<
  CreateSigintSensorSecurityOption2$Outbound,
  CreateSigintSensorSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function createSigintSensorSecurityOption2ToJSON(
  createSigintSensorSecurityOption2: CreateSigintSensorSecurityOption2,
): string {
  return JSON.stringify(
    CreateSigintSensorSecurityOption2$outboundSchema.parse(
      createSigintSensorSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateSigintSensorSecurity$Outbound = {
  Option1?: CreateSigintSensorSecurityOption1$Outbound | undefined;
  Option2?: CreateSigintSensorSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateSigintSensorSecurity$outboundSchema: z.ZodMiniType<
  CreateSigintSensorSecurity$Outbound,
  CreateSigintSensorSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateSigintSensorSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateSigintSensorSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createSigintSensorSecurityToJSON(
  createSigintSensorSecurity: CreateSigintSensorSecurity,
): string {
  return JSON.stringify(
    CreateSigintSensorSecurity$outboundSchema.parse(createSigintSensorSecurity),
  );
}

/** @internal */
export type CreateSigintSensorRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateSigintSensorForm: CreateSigintSensorForm$Outbound;
};

/** @internal */
export const CreateSigintSensorRequest$outboundSchema: z.ZodMiniType<
  CreateSigintSensorRequest$Outbound,
  CreateSigintSensorRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createSigintSensorForm: CreateSigintSensorForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createSigintSensorForm: "CreateSigintSensorForm",
    });
  }),
);

export function createSigintSensorRequestToJSON(
  createSigintSensorRequest: CreateSigintSensorRequest,
): string {
  return JSON.stringify(
    CreateSigintSensorRequest$outboundSchema.parse(createSigintSensorRequest),
  );
}
